import React from 'react';
import UITextInput from '../..';
import "./styles.css";

/**
 * @function UIExplanationTextInput
 * @return {React.Component}
 * @exported true
 * @description The explanation text input
 */

export default function UIExplanationTextInput(props){
  const className = props.className ?? "";
  const placeholderText = props.placeholderText !== undefined ? (props.placeholderText) : (" ");
  const placeholder = props.placeholder ?? "Explanation";
  const value = props.value ?? "";
  const inputDataPoint = props.dataPoint ? { "dataPoint": props.dataPoint } : {};
  const subTextDataPoint = props.dataPoint ? { "data-point": props.dataPoint + "_Chars_Remaining_Label" } : {};
  const onChange = props.onChange ? props.onChange : undefined;
  const maxLength = props.maxLength !== undefined ? { maxLength: props.maxLength } : {};
  const charLimit = props.maxLength !== undefined ? parseInt(props.maxLength) : 300;
  const currValLength = value.length;
  const charRemaining = charLimit - currValLength;
  
  return(
    <div className={className + " ui-explanation-text-input"}>
        <UITextInput placeholder={placeholder} placeholderText={placeholderText} { ...maxLength } { ...inputDataPoint } value={value} onChange={ onChange } />
        <p className="sub-text" { ...subTextDataPoint }>{ charRemaining } of { charLimit } characters remaining</p>
    </div>
  );
}